import { clsx } from 'clsx';
import { ReactNode } from 'react';
import { useCollapse } from 'react-collapsed';

import { ArrowDownIcon } from '@/components/icons/main-block';

import cn from './styles.module.sass';

interface IFAQCollapsibleProps {
    title: string;
    content: ReactNode;
}

export const FAQCollapsible = ({ title, content }: IFAQCollapsibleProps) => {
    const { getToggleProps, getCollapseProps, isExpanded } = useCollapse();

    return (
        <div className={cn.container} {...getToggleProps()}>
            <div className={cn.head}>
                <div className={cn.title}>{title}</div>
                <div className={clsx(cn.arrowIcon, isExpanded && cn.active)}>{ArrowDownIcon}</div>
            </div>
            <div className={cn.content} {...getCollapseProps()}>
                <div className={cn.contentContainer}>{content}</div>
            </div>
        </div>
    );
};
